// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f3005977","337":"cbf2b998","453":"0098adef","455":"1e7c88e9"}[chunkId] + ".chunk.js";
};